// Purpose: format constants mirroring docs/CRYPTO_FORMAT.md §12.
// Intentionally duplicated with packages/crypto/src/constants.ts so this
// package depends on nothing node-specific. The interop test proves they
// agree on wire format.

export const MAGIC = new Uint8Array([0x41, 0x53, 0x54, 0x2d, 0x43, 0x52, 0x59, 0x50]); // "AST-CRYP"

export const FORMAT_VERSION = 0x01;
export const ALGO_AES_256_GCM = 0x01;

export const CHUNK_SIZE_BYTES = 4 * 1024 * 1024;
export const GCM_TAG_BYTES = 16;
export const NONCE_BYTES = 12;
export const FILE_SALT_BYTES = 4;
export const CHUNK_COUNTER_BYTES = 8;

export const HEADER_BYTES = 8 + 1 + 1 + 2 + 4 + 4 + 32;

export const CHUNK_LENGTH_FIELD_BYTES = 4;
export const LAST_CHUNK_FLAG = 0x80000000;
export const LENGTH_MASK = 0x7fffffff;

export const OFFSET_MAGIC = 0;
export const OFFSET_VERSION = 8;
export const OFFSET_ALGO = 9;
export const OFFSET_RESERVED = 10;
export const OFFSET_CHUNK_SIZE = 12;
export const OFFSET_FILE_SALT = 16;
export const OFFSET_SIZE_COMMITMENT = 20;

export const DEK_BYTES = 32;
